// we cannot just check if innerHTML === ""
// as there can be ascii characters or empty <br> tags
export const checkIfTextBoxIsEmpty = (innerHTML: string) => {
    const div = document.createElement("div");
    div.innerHTML = innerHTML;
    return !div.textContent;
};
